import { ChapterType, ExerciseScene } from 'Types/ExerciseData';
import { AddEventsAndMergeTimestamps, Timestamps } from 'Utils/ChaptersToTimestamps';
import timestamps from './level4.json';
import { Exercise, Lecture, PianoScene, Section, Tutorial } from 'Utils/TutorialConfigHelper';

// This is still using the old JSON way of defining levels
const Level4 = Tutorial(4, '1:49', [
  Section([
    Lecture('E in the Treble Clef', '0:0'),
    Lecture('E on the Keyboard', '0:13'),
    Exercise(
      'Find E',
      '0:29',
      PianoScene({
        start: 'A0',
        end: 'C8',
        transition: 'Dissolve',
        textPromptPosition: 'Top',
        objectives: [
          {
            text: 'Play E on your keyboard.',
            target: 'E4',
          },
        ],
      }),
      [],
    ),
  ]),
  {
    chapters: [
      {
        title: 'Playing with the 3rd Finger',
        start: '0:36',
        data: [ChapterType.Lecture],
      },
      {
        title: 'Playing E',
        start: '0:42',
        data: [
          ChapterType.Exercise,
          {
            scene: [
              ExerciseScene.NoTimeExercise,
              {
                centre_align_horizontal: false,
                padding_x: 100,
                firstObjectiveAppearDelay: 1500,
                objectives: [{}],
              },
            ],
            events: [],
          },
        ],
      },
      {
        title: 'Using the First 3 Fingers',
        start: '0:49',
        data: [ChapterType.Lecture],
      },
      {
        title: 'Alternating Fingers',
        start: '1:08',
        data: [
          ChapterType.Exercise,
          {
            scene: [
              ExerciseScene.NoTimeExercise,
              {
                centre_align_horizontal: true,
                padding_x: 0,
                firstObjectiveAppearDelay: 1500,
                objectives: [
                  {
                    text: 'Play these notes at your own pace.',
                  },
                  {
                    text: 'Play these notes at your own pace.',
                  },
                  {
                    text: 'Play these notes at your own pace.',
                  },
                ],
              },
            ],
            events: [],
          },
        ],
      },
      {
        title: 'Playing in Time',
        start: '1:30',
        data: [
          ChapterType.Exercise,
          {
            scene: [
              ExerciseScene.StaffExercise,
              {
                objectives: [
                  {
                    text: 'Play this line of music in sync with the metronome.',
                    paddingHorizontal: 20,
                    phrases: [],
                  },
                  {
                    text: 'Play this line of music in sync with the metronome.',
                    paddingHorizontal: 20,
                    phrases: [],
                  },
                ],
              },
            ],
            events: [],
          },
        ],
      },
    ],
  },
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level4);
